import { User } from "lucide-react";
import { cn } from "../../lib/utils";

const PALETTE = [
  "bg-blue-500", "bg-violet-500", "bg-rose-500", "bg-amber-500", "bg-emerald-500",
  "bg-cyan-500", "bg-pink-500", "bg-indigo-500", "bg-teal-500", "bg-orange-500"
];

function hashString(str = "") {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

interface UserAvatarProps {
  user?: { name?: string | null; displayName?: string | null; username?: string | null; email?: string | null; avatarUrl?: string | null };
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function UserAvatar({ user, size = "md", className }: UserAvatarProps) {
  const name = user?.displayName || user?.name || user?.username || user?.email || "User";
  const initials = name
    .trim()
    .split(/\s+/)
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const color = PALETTE[hashString(name) % PALETTE.length];

  const sizeClasses = {
    sm: "w-7 h-7 text-xs",
    md: "w-8 h-8 text-sm",
    lg: "w-10 h-10 text-base",
  }[size];

  if (user?.avatarUrl) {
    return (
      <img
        src={user.avatarUrl}
        alt={name}
        className={cn("rounded-full object-cover shrink-0", sizeClasses, className)}
      />
    );
  }

  return (
    <div
      className={cn(
        "rounded-full flex items-center justify-center font-medium text-white shrink-0 shadow-sm",
        color,
        sizeClasses,
        className
      )}
    >
      {initials || <User className="w-4 h-4" />}
    </div>
  );
}
